import * as React from "react"
import * as Antd from "antd"
import styles from "./DvSelect.module.scss"

import { useTranslation } from "react-i18next"

interface IProps extends Antd.SelectProps {
	className?: string
	placeholder?: string
}

const DvSelect: React.FC<IProps> = ({ className, placeholder, ...props }) => {
	const { t } = useTranslation()

	return (
		<Antd.Select
			className={`${styles.dv_select} ${className || ""}`}
			showSearch
			placeholder={placeholder || t("select_an_option")}
			getPopupContainer={() =>
				document.getElementsByClassName(
					styles.dv_select
				)[0] as HTMLElement
			}
			filterOption={(input, option) =>
				(option?.label as string)
					?.toLowerCase()
					.includes(input.toLowerCase())
			}
			{...props}
		/>
	)
}

export default React.memo(DvSelect)
